export enum Language {
    SANSKRIT = 'sa',
    ENGLISH = 'en',
    HINDI = 'hi',
    KANNADA = 'kn',
    TAMIL = 'ta',
    TELUGU = 'te',
    MALAYALAM = 'ma'
}

export interface Meaning {
    id: number;
    language: Language;
    text: string;
} 